import _ from 'lodash';
import router from '../../router';
import questions from '../../pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/consts/questions';
import valueProps from '../../pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/consts/value-props';

const state = {
  componentName: null,
  componentType: null,
  componentTypes: {
    QUESTION: 'question',
    VALUE_PROP: 'valueProp',
  },
  answers: {},
};

const getters = {
  componentOrder: state => [
    {
      componentType: state.componentTypes.QUESTION,
      name: questions.QUESTION_NAMES.FINANCIAL_CONTROL,
    },
    {
      componentType: state.componentTypes.QUESTION,
      name: questions.QUESTION_NAMES.IS_INCOME_FIXED,
    },
    {
      componentType: state.componentTypes.QUESTION,
      name: questions.QUESTION_NAMES.HANDLE_UNEXPECTED_EXPENSE,
    },
    {
      componentType: state.componentTypes.QUESTION,
      name: questions.QUESTION_NAMES.JOB_TO_BE_DONE,
    },
    {
      componentType: state.componentTypes.VALUE_PROP,
      name: valueProps.VALUE_PROP_NAMES.CASHFLOW_GOAL,
    },
    {
      componentType: state.componentTypes.VALUE_PROP,
      name: valueProps.VALUE_PROP_NAMES.CONTROL,
    },
    {
      componentType: state.componentTypes.VALUE_PROP,
      name: valueProps.VALUE_PROP_NAMES.ONE_NUMBER,
    },
    {
      componentType: state.componentTypes.VALUE_PROP,
      name: valueProps.VALUE_PROP_NAMES.FINANCIAL_ADVICE,
    },
  ],
  currentQuestion: state => _.find(questions.QUESTIONS, { name: state.componentName }),
  questionIndex: (state, getters) => _.chain(getters.componentOrder)
    .filter({ componentType: state.componentTypes.QUESTION })
    .findIndex({ name: state.componentName })
    .value(),
  pageIndex: (state, getters) => _.findIndex(getters.componentOrder, { componentType: state.componentType, name: state.componentName }),
};

const actions = {
  gotoPage({ commit }, { componentName, componentType }) {
    commit('setComponentName', componentName);
    commit('setComponentType', componentType);
  },
  nextPage({ state, getters, commit }, { questionName, answer }) {
    commit('addAnswer', { questionName, answer });
    if (getters.pageIndex === getters.componentOrder.length - 1) {
      return router.push({ path: '/signup/lq/finish' });
    }
    const nextComponent = getters.componentOrder[getters.pageIndex + 1];
    commit('setComponentName', nextComponent.name);
    commit('setComponentType', nextComponent.componentType);

    if (nextComponent.componentType === state.componentTypes.QUESTION) {
      return router.push({ path: `/signup/lq/question/${nextComponent.name}` });
    }
    return router.push({ path: `/signup/lq/vp/${nextComponent.name}` });
  },
};

const mutations = {
  setComponentName(state, componentName) {
    state.componentName = componentName; // eslint-disable-line
  },
  setComponentType(state, componentType) {
    state.componentType = componentType; // eslint-disable-line
  },
  addAnswer(state, { questionName, answer }) {
    state.answers = { ...state.answers, [questionName]: answer } // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/leadQualification.js